import { render, staticRenderFns } from "./BodyPartImage.vue?vue&type=template&id=0fc10ce6&scoped=true&"
import script from "./BodyPartImage.vue?vue&type=script&lang=js&"
export * from "./BodyPartImage.vue?vue&type=script&lang=js&"
import style0 from "./BodyPartImage.vue?vue&type=style&index=0&id=0fc10ce6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc10ce6",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/elements/BodyPartImage.vue
// module id = null
// module chunks = 